import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import times from "lodash/times";
import styles from "./RatingDisplay.module.css";
import StarSvg from "src/components/svg/StarSvg";
import getFraction from "src/lib/filmwebid/getFraction";
import type { MouseEventHandler } from "react";
const MAX_RATING = Number(process.env.NEXT_PUBLIC_MAX_USER_RATING_VALUE ?? 5);

//#region [Props]
type RatingDisplayProps = {
  maxRatingValue?: number;
  className?: string;
  ratingValue: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  roundTo?: number;
};
//#endregion

//#region [Component]
export default function RatingDisplay(t0) {
  const $ = _c(17);
  const {
    className,
    maxRatingValue: t1,
    ratingValue,
    onClick,
    roundTo
  } = t0;
  const maxRatingValue = t1 === undefined ? MAX_RATING : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== className || $[1] !== maxRatingValue || $[2] !== onClick || $[3] !== ratingValue || $[4] !== roundTo) {
    const ratingNumberer = times(maxRatingValue, _temp);
    if ($[8] !== className) {
      t2 = classNames(styles.RatingDisplay, className);
      $[8] = className;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t3 = onClick;
    let t5;
    if ($[10] !== ratingValue || $[11] !== roundTo) {
      t5 = i_0 => <StarSvg data-max={MAX_RATING} key={`sc1_${i_0}`} className={classNames("star", styles.AverageMarker)} fractionSelected={getFraction(ratingValue, i_0, roundTo)} />;
      $[10] = ratingValue;
      $[11] = roundTo;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = ratingNumberer.map(t5);
    $[0] = className;
    $[1] = maxRatingValue;
    $[2] = onClick;
    $[3] = ratingValue;
    $[4] = roundTo;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className={t2} onClick={t3}>{t4}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
//#endregion
function _temp(i) {
  return i + 1;
}